import { cn } from "@paribus/shared-ui";
import React from "react";

export const VISITS_TOOLBAR_NATIVE_SELECT_STYLE: React.CSSProperties = {
  appearance: "none",
  backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 0 center",
  backgroundSize: "14px",
  boxShadow: "none",
};

const baseSelectClass =
  "min-w-0 flex-1 truncate bg-transparent text-xs font-bold text-neutral-800 focus:outline-none focus-visible:shadow-focus-inset cursor-pointer py-1 pr-5 ring-0 outline-none border-none focus:ring-0 focus:border-none";

export type VisitsToolbarNativeSelectProps = Omit<
  React.ComponentPropsWithRef<"select">,
  "style" | "className"
> & {
  className?: string;
};

export const VisitsToolbarNativeSelect = React.forwardRef<
  HTMLSelectElement,
  VisitsToolbarNativeSelectProps
>(({ className, ...rest }, ref) => (
  <select
    ref={ref}
    className={cn(baseSelectClass, className)}
    style={VISITS_TOOLBAR_NATIVE_SELECT_STYLE}
    {...rest}
  />
));

VisitsToolbarNativeSelect.displayName = "VisitsToolbarNativeSelect";
